import { TREE_CONDITIONS } from '@api/types'
import { useI18n } from '@i18n/I18nProvider'
import { CONDITION_HEX, POI_HEX, ROUTE_HEX, TRACK_HEX } from '@ui/colors'
import { Icon } from '@ui/Icon'
import { STAGE_END_ICONS } from './markers'

const ITEM = 'flex min-h-10 items-center gap-3'

// Leyenda del mapa (en la hoja del botón "i", LegendButton), siempre con texto: los árboles (círculos) por estado y los lugares de
// interés (cuadrados), con la misma forma que sus marcadores; los grupos (de lejos) y su marca
// de avisos. Con una etapa elegida, también su salida y su llegada.
export const Legend = ({ withStageEnds = false }: { withStageEnds?: boolean }) => {
	const { t } = useI18n()
	return (
		<ul aria-label={t('map.legend')} className="grid gap-2 text-lg">
			{[...TREE_CONDITIONS, 'none' as const].map((condition) => (
				<li key={condition} className={ITEM}>
					<span
						className="mx-1.5 size-4 shrink-0 rounded-full"
						style={{ backgroundColor: CONDITION_HEX[condition] }}
						aria-hidden="true"
						data-shape="circle"
					/>
					{t(`condition.${condition}`)}
				</li>
			))}
			<li className={ITEM}>
				<span
					className="mx-1.5 size-4 shrink-0 rounded-[3px]"
					style={{ backgroundColor: POI_HEX.heritage }}
					aria-hidden="true"
					data-shape="square"
				/>
				{t('map.poi')}
			</li>
			<li className={ITEM}>
				<span
					className="mx-1 size-5 shrink-0 rounded-full border-[3px] bg-white"
					style={{ borderColor: TRACK_HEX }}
					aria-hidden="true"
					data-shape="variant"
				/>
				{t('map.variant')}
			</li>
			<li className={ITEM}>
				<span
					className="flex size-7 shrink-0 items-center justify-center rounded-full border-2 bg-white text-xs font-bold"
					style={{ borderColor: ROUTE_HEX, color: ROUTE_HEX }}
					aria-hidden="true"
					data-shape="cluster"
				>
					9
				</span>
				{t('map.cluster')}
			</li>
			<li className={ITEM}>
				<span
					className="mx-0.5 flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white"
					style={{ backgroundColor: CONDITION_HEX.damaged }}
					aria-hidden="true"
					data-shape="alert"
				>
					2
				</span>
				{t('map.clusterAlerts')}
			</li>
			{withStageEnds &&
				(['start', 'finish'] as const).map((end) => (
					<li key={end} className={ITEM}>
						<span
							className="mx-0.5 flex size-6 shrink-0 items-center justify-center rounded-full text-white"
							style={{ backgroundColor: ROUTE_HEX }}
							aria-hidden="true"
						>
							<Icon name={STAGE_END_ICONS[end]} className="size-3.5" />
						</span>
						{t(end === 'start' ? 'map.start' : 'map.finish')}
					</li>
				))}
		</ul>
	)
}
